import React from 'react';
import Tracking from '@vromo/analytics';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useStore } from '@vromo/mobx-react';
import FontAwesome from '@vromo/ui/components/FontAwesome';

const Container = styled.div`
    font-weight: 500;
    color: #182d3c;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    align-self: stretch;
    padding: 0 20px;
`;

const Icon = styled(FontAwesome)`
    width: 32px;
    margin: 12px 0;
    font-size: 22px;
`;

const Link = styled.a`
    color: #182d3c;
    text-decoration: none;
    font-size: 17px;
    font-weight: 500;
    font-family: Helvetica Neue, Helvetica, 'open sans', Arial, sans-serif;
`;

export default observer(function Contact({ aaac }: { aaac: boolean }) {
    return (
        <Container>
            <Link
                href="tel:92480008"
                onClick={() => Tracking.track('Call RAC Button Pressed')}
                target="_blank">
                <Icon icon="phone" large /> Call Novus
            </Link>
            {aaac ? (
                <Link
                    href="https://racinsurance.rac.com.au/Claim2/Preamble/Questions/6e5edbd4-60a8-4071-8b34-1370eb0be8fd"
                    onClick={() => Tracking.track('RAC Link Opened')}
                    target="_blank">
                    <Icon icon="external-link" large /> Make a claim
                </Link>
            ) : (
                <Link
                    href="https://rac.com.au"
                    onClick={() => Tracking.track('RAC Link Opened')}
                    target="_blank">
                    <Icon icon="external-link-alt" large /> Visit rac.com.au
                </Link>
            )}
        </Container>
    );
});
